import React, { useState } from 'react';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import PersonIcon from '@material-ui/icons/Person';
import Typography from '@material-ui/core/Typography';
import { USER_TYPES } from 'constant/userTypes';
import Box from '@material-ui/core/Box';
import get from 'lodash/get';
import Link from '@material-ui/core/Link';
import Divider from '@material-ui/core/Divider';
import Button from 'components/common/Button';
import Card from '@material-ui/core/Card';
import { makeStyles } from '@material-ui/core/styles';
import BioModal from './BioModal';

const useStyles = makeStyles((theme) => ({
  profileCard: {
    height: `100%`,
    display: 'flex',
    flexDirection: 'column',
  },
  cardContent: {
    padding: theme.spacing(3),
    paddingBottom: 0,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
  },
  cardActions: {
    padding: theme.spacing(3),
    textAlign: 'center',
  },
  bio: {
    display: 'box',
    lineClamp: 3,
    overflow: 'hidden',
    boxOrient: 'vertical',
  },
  action: {
    textAlign: 'center',
  },
  avatar: {
    width: 50,
    height: 50,
    borderRadius: '50%',
    border: '3px solid',
    borderColor: theme.palette.primary.light,
    marginRight: theme.spacing(3),
  },
}));

const BioCard = ({ profile, handleSchedule }) => {
  const classes = useStyles();
  const [showBio, setShowBio] = useState();
  const onCloseBio = () => setShowBio(false);

  return (
    <Card className={classes.profileCard}>
      <CardContent className={classes.cardContent}>
        <div className={classes.cardHeader}>
          <Avatar
            className={classes.avatar}
            src={profile.user_pic}
          >
            <PersonIcon fontSize="large" />
          </Avatar>
          <div>
            <Typography variant="subtitle1">
              {profile.user_first_name} {profile.user_last_name}
            </Typography>
            <Typography gutterBottom color="textSecondary">
              {USER_TYPES[profile.user_type]}
            </Typography>
          </div>
        </div>
        <Box marginBottom={4} flex={1}>
          <Typography variant="caption" className={classes.bio}>
            {get(profile, 'profile.0.bio')}{' '}
          </Typography>
          <Link href="#" onClick={() => setShowBio(profile)}>
            Read more
          </Link>
        </Box>
        <Divider />
      </CardContent>
      {handleSchedule && (
        <Box className={classes.cardActions}>
          <Button
            onClick={() => handleSchedule(profile)}
            color="primary"
            variant="contained"
          >
            Schedule a session
          </Button>
        </Box>
      )}
      {showBio && <BioModal user={showBio} onClose={onCloseBio} />}
    </Card>
  )
}

export default BioCard;